'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { cleanPhoneNumber } from '@/services/phone';
import { signIn } from '@/services/webApi';
import { emailSchema } from '@goodneighbor/api/schemas/auth';

export type PartnerLoginInput = {
  email: string;
  password: string;
};

export function usePartnerLogin() {
  const queryClient = useQueryClient();
  const router = useRouter();

  const signInMutation = useMutation({
    mutationFn: async ({ email, password }: PartnerLoginInput) => {
      const isEmail = emailSchema.safeParse(email).success;
      const phoneOrEmail = isEmail
        ? email.toLowerCase()
        : cleanPhoneNumber(email);

      return signIn({
        phoneOrEmail,
        password,
        intent: 'partner'
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account'] });
      router.replace('/partner/dashboard');
    }
  });

  const handleSubmit = (data: PartnerLoginInput) => {
    signInMutation.mutate(data);
  };

  return {
    signInMutation,
    handleSubmit
  };
}
